function convertNumberToCompactFormat(amount: number, maximumFractionDigits = 1) {
  try {
    return amount.toLocaleString('en-US', {
      notation: 'compact',
      maximumFractionDigits
    });
  } catch {
    // fallback to old browsers
    if (amount >= 1e9) {
      return `${(amount / 1e9).toFixed(1)}B`;
    }

    if (amount >= 1e6) {
      return `${(amount / 1e6).toFixed(1)}M`;
    }

    if (amount >= 1e3) {
      return `${(amount / 1e3).toFixed(1)}K`;
    }

    return amount.toString();
  }
}

export default convertNumberToCompactFormat;
